/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom"; // URL id edukka
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";
import Select from "react-select";
import dayjs from "dayjs";
import Flatpickr from "react-flatpickr";
import { Row, Col, Button, Input, Table, Card, CardBody } from "reactstrap";

const FLATPICKR_CONFIG = {
    minDate: "today",
    dateFormat: "Y-m-d",
    closeOnSelect: false
};

const EditQuotation = () => {
    const { id } = useParams(); 
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [customers, setCustomers] = useState([]);
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [items, setItems] = useState([]);

    const [form, setForm] = useState({
        customer_id: null,
        ref: "",
        valid_until: dayjs().add(7, 'day').format("YYYY-MM-DD"),
    });

    // 1. Initial Load: Customers list load pannuvom
    useEffect(() => {
        const init = async () => {
            dispatch(loadingTrue());

            // Fetch Customers
            const resCust = await Handler({ method: "get", url: "/customer/list.php?status=active&limit=1000" });
            if (resCust?.success) {
                setCustomers(resCust.data.map(c => ({ value: c.id, label: c.company_name })));
            }

            // 2. ⭐ Edit mode-ah irundha Quotation Data load pannuvom
            if (id) {
                const resView = await Handler({ method: "get", url: `/quotation/view.php?id=${id}` });
                if (resView?.success) {
                    const q = resView.data;

                    // Form data-ah set panren
                    setForm({
                        customer_id: q.customer_id,
                        ref: q.ref,
                        valid_until: q.valid_until
                    });

                    // Customer change trigger panni vehicles load pannanum
                    await fetchVehicles(q.customer_id, q.items);
                }
            }
            dispatch(loadingFalse());
        };
        init();
    }, [id, dispatch]);

    // 3. ⭐ Customer based vehicle list fetch panni items-ah pre-select pannuvaom
    const fetchVehicles = async (cId, existingItems = []) => {
        const res = await Handler({
            method: "get",
            url: `/quotation/get_rate.php?customer_id=${cId}`
        });

        if (res?.success) {
            const formattedOptions = res.data.map(v => ({
                value: String(v.vehicle_id),
                label: v.lorry_type,
                rates: v
            }));
            setVehicleOptions(formattedOptions);

            // Pre-select vehicles if editing
            if (existingItems.length > 0) {
                const mappedItems = existingItems.map(ei => {
                    const rateData = res.data.find(r => String(r.vehicle_id) === String(ei.vehicle_id)) || {};
                    return {
                        vehicle_id: String(ei.vehicle_id),
                        vehicle_label: ei.lorry_type,
                        item_ref: ei.item_ref || "",
                        rates: rateData,
                        normal_hours: ei.normal_hours || 0,
                        normal_hours_ot: ei.normal_hours_ot || 0,
                        after_office_hours: ei.after_office_hours || 0,
                        offz_hours_ot: ei.offz_hours_ot || 0,
                        holiday_hours: ei.holiday_hours || 0
                    };
                });
                setItems(mappedItems);
            }
        }
    };

    const handleCustomerChange = async (opt) => {
        const cId = opt ? opt.value : null;
        setForm(prev => ({ ...prev, customer_id: cId }));
        setItems([]);
        setVehicleOptions([]);
        if (cId) {
            dispatch(loadingTrue());
            await fetchVehicles(cId);
            dispatch(loadingFalse());
        }
    };

    const handleVehicleSelect = (selectedOpts) => {
        const currentSelection = selectedOpts || [];
        const updatedItems = currentSelection.map(opt => {
            const existing = items.find(it => String(it.vehicle_id) === String(opt.value));
            if (existing) return existing;

            return {
                vehicle_id: String(opt.value),
                vehicle_label: opt.label,
                item_ref: "",
                rates: opt.rates,
                normal_hours: 0,
                normal_hours_ot: 0,
                after_office_hours: 0,
                offz_hours_ot: 0,
                holiday_hours: 0
            };
        });
        setItems(updatedItems);
    };

    const handleItemEntry = (index, field, value) => {
        const updated = [...items];
        const val = field === "item_ref" ? value : (value === "" ? 0 : Number(value));
        updated[index][field] = val;
        setItems(updated);
    };

    const calculateLineTotal = (item) => {
        const r = item.rates || {};
        const total =
            (Number(item.normal_hours || 0) * Number(r.normal_hrs || 0)) +
            (Number(item.normal_hours_ot || 0) * Number(r.normal_hrs_ot || 0)) +
            (Number(item.after_office_hours || 0) * Number(r.after_office_hrs || 0)) +
            (Number(item.offz_hours_ot || 0) * Number(r.offz_hrs_ot || 0)) +
            (Number(item.holiday_hours || 0) * Number(r.holiday || 0));
        return Number(total).toFixed(2);
    };

    const calculateGrandTotal = () => {
        return items.reduce((acc, it) => acc + Number(calculateLineTotal(it)), 0).toFixed(2);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.customer_id || items.length === 0) return toast.error("Please fill all required fields");

        dispatch(loadingTrue());
        const payload = {
            quotation_id: id || null, // Edit-na id pogum, create-na null
            customer_id: form.customer_id,
            ref: form.ref,
            valid_until: dayjs(form.valid_until).format("YYYY-MM-DD"),
            items: items.map(it => ({
                vehicle_id: it.vehicle_id,
                item_ref: it.item_ref,
                normal_hours: it.normal_hours,
                normal_hours_ot: it.normal_hours_ot,
                after_office_hours: it.after_office_hours,
                offz_hours_ot: it.offz_hours_ot,
                holiday_hours: it.holiday_hours,
                line_total: calculateLineTotal(it)
            }))
        };

        const url = id ? "/quotation/update.php" : "/quotation/create.php";
        const res = await Handler({ method: "post", url: url, data: payload });

        if (res?.success) {
            toast.success(id ? "Quotation Updated!" : "Quotation Generated!");
            setTimeout(() => reloadWindowToPath("/quotations"), 1500);
        } else {
            toast.error(res?.message || "Operation failed");
        }
        dispatch(loadingFalse());
    };

    return (
        <div className="page-card p-4 shadow-sm border-0 rounded-4 bg-white">
            <h4 className="fw-bold text-dark mb-4 border-bottom pb-2">
                {id ? `Edit Quotation (#${id})` : "Create Quotation"}
            </h4>

            <form onSubmit={handleSubmit}>
                <Row className="g-3 mb-4">
                    <Col md={3}>
                        <label className="form-label small text-muted fw-bold">Customer *</label>
                        <Select
                            options={customers}
                            value={customers.find(c => String(c.value) === String(form.customer_id))}
                            onChange={handleCustomerChange}
                            placeholder="Select customer"
                            isClearable
                        />
                    </Col>
                    <Col md={3}>
                        <label className="form-label small text-muted fw-bold">Main Reference</label>
                        <Input placeholder="General Ref" value={form.ref} onChange={e => setForm({ ...form, ref: e.target.value })} />
                    </Col>
                    <Col md={3}>
                        <label className="form-label small text-muted fw-bold">Select Vehicles *</label>
                        <Select
                            isMulti
                            options={vehicleOptions}
                            value={vehicleOptions.filter(o => items.some(it => String(it.vehicle_id) === String(o.value)))}
                            onChange={handleVehicleSelect}
                            isDisabled={!form.customer_id}
                            closeMenuOnSelect={false}
                        />
                    </Col>
                    <Col md={3}>
                        <label className="form-label small text-muted fw-bold">Valid Until *</label>
                        <Flatpickr className="form-control" value={form.valid_until} onChange={([d]) => setForm({ ...form, valid_until: d })} options={FLATPICKR_CONFIG} />
                    </Col>
                </Row>

                {/* --- Unit Rates Table --- */}
                {items.length > 0 && (
                    <div className="mb-4">
                        <h6 className="fw-bold text-secondary mb-3 small uppercase">Unit Rates Tracking</h6>
                        <Table className="text-center align-middle" size="sm" bordered responsive>
                            <thead className="table-dark small">
                                <tr>
                                    <th>Vehicle</th>
                                    <th>Normal</th><th>N-OT</th><th>After</th><th>O-OT</th><th>Holiday</th>
                                </tr>
                            </thead>
                            <tbody className="small">
                                {items.map(it => (
                                    <tr key={it.vehicle_id}>
                                        <td className="fw-bold">{it.vehicle_label}</td>
                                        <td>${it.rates?.normal_hrs}</td>
                                        <td>${it.rates?.normal_hrs_ot}</td>
                                        <td>${it.rates?.after_office_hrs}</td>
                                        <td>${it.rates?.offz_hrs_ot}</td>
                                        <td>${it.rates?.holiday}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}

                {/* --- Dynamic Vehicle Cards --- */}
                {items.map((item, index) => (
                    <Card key={item.vehicle_id} className="mb-3 border-0 shadow-sm bg-light rounded-4">
                        <CardBody>
                            <div className="d-flex justify-content-between mb-3 align-items-center">
                                <h6 className="fw-bold text-primary mb-0">{item.vehicle_label}</h6>
                                <span className="badge bg-success px-3 py-2 fs-6">Total: ${calculateLineTotal(item)}</span>
                            </div>
                            <Row className="g-2">
                                <Col md={2}><label className="extra-small fw-bold">Ref</label><Input type="text" value={item.item_ref || ""} onChange={e => handleItemEntry(index, "item_ref", e.target.value)} /></Col>
                                <Col md={2}><label className="extra-small fw-bold">Normal</label><Input type="number" step="any" value={item.normal_hours || ""} onChange={e => handleItemEntry(index, "normal_hours", e.target.value)} /></Col>
                                <Col md={2}><label className="extra-small fw-bold">N-OT</label><Input type="number" step="any" value={item.normal_hours_ot || ""} onChange={e => handleItemEntry(index, "normal_hours_ot", e.target.value)} /></Col>
                                <Col md={2}><label className="extra-small fw-bold">After</label><Input type="number" step="any" value={item.after_office_hours || ""} onChange={e => handleItemEntry(index, "after_office_hours", e.target.value)} /></Col>
                                <Col md={2}><label className="extra-small fw-bold">O-OT</label><Input type="number" step="any" value={item.offz_hours_ot || ""} onChange={e => handleItemEntry(index, "offz_hours_ot", e.target.value)} /></Col>
                                <Col md={2}><label className="extra-small fw-bold">Holiday</label><Input type="number" step="any" value={item.holiday_hours || ""} onChange={e => handleItemEntry(index, "holiday_hours", e.target.value)} /></Col>
                            </Row>
                        </CardBody>
                    </Card>
                ))}

                {items.length > 0 && (
                    <div className="text-end pt-4 mt-3 border-top">
                        <h2 className="fw-bold text-success mb-3">Grand Total: ${calculateGrandTotal()}</h2>
                        <Button color="primary" size="lg" className="px-5 rounded-pill shadow" type="submit" disabled={loading}>
                            {loading ? "Saving..." : (id ? "Update Quotation" : "Generate Quotation")}
                        </Button>
                    </div>
                )}
            </form>
        </div>
    );
};

export default EditQuotation;